const types = {
	FETCH_PENDING_BIDS_START: 'FETCH_PENDING_BIDS_START',
	FETCH_PENDING_BIDS_ERROR: 'FETCH_PENDING_BIDS_ERROR',
	FETCH_PENDING_BIDS_SUCCESS: 'FETCH_PENDING_BIDS_SUCCESS',
	DELETE_BID_START: 'DELETE_BID_START',
	DELETE_BID_ERROR: 'DELETE_BID_ERROR',
	DELETE_BID_SUCCESS: 'DELETE_BID_SUCCESS'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/pending-bid-list/mutation-types.js